// src/components/Home/CookieBanner.tsx
import React, { useState, useEffect } from 'react';
import { Cookie, X, ShieldCheck, ExternalLink } from 'lucide-react';

const COOKIE_KEY = 'fpb_cookie_consent';

const CookieBanner: React.FC = () => {
  const [visivel, setVisivel] = useState(false);

  useEffect(() => {
    // Só mostra se o usuário ainda não respondeu
    const resposta = localStorage.getItem(COOKIE_KEY);
    if (!resposta) setVisivel(true);
  }, []);

  const aceitar = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisivel(false);
  };

  const recusar = () => {
    localStorage.setItem(COOKIE_KEY, 'declined');
    setVisivel(false);
  };

  if (!visivel) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 p-4 md:p-6
      animate-in slide-in-from-bottom duration-500">
      <div className="max-w-5xl mx-auto bg-white rounded-2xl shadow-2xl border border-gray-200
        flex flex-col md:flex-row items-start md:items-center gap-4 p-5 md:p-6">

        {/* Ícone */}
        <div className="flex-shrink-0 w-11 h-11 rounded-xl bg-amber-100 flex items-center justify-center">
          <Cookie className="w-5 h-5 text-amber-600" />
        </div>

        {/* Texto */}
        <div className="flex-1 min-w-0">
          <p className="text-sm font-bold text-gray-900 mb-1 flex items-center gap-2">
            <ShieldCheck className="w-4 h-4 text-green-600 flex-shrink-0" />
            Este site utiliza cookies
          </p>
          <p className="text-xs text-gray-500 leading-relaxed">
            Usamos cookies para melhorar sua experiência, personalizar conteúdo e analisar
            nosso tráfego. Ao continuar navegando, você concorda com nossa{' '}
            <a
              href="/lgpd"
              className="text-blue-600 hover:underline font-semibold inline-flex items-center gap-0.5"
            >
              Política de Privacidade
              <ExternalLink className="w-3 h-3" />
            </a>
            {' '}e com a{' '}
            <a
              href="/lgpd"
              className="text-blue-600 hover:underline font-semibold inline-flex items-center gap-0.5"
            >
              LGPD
              <ExternalLink className="w-3 h-3" />
            </a>
            .
          </p>
        </div>

        {/* Botões */}
        <div className="flex items-center gap-2 flex-shrink-0 w-full md:w-auto">
          <button
            onClick={recusar}
            className="flex-1 md:flex-none px-4 py-2.5 rounded-xl border-2 border-gray-300
              text-gray-600 text-sm font-bold hover:bg-gray-50 transition-colors"
          >
            Recusar
          </button>
          <button
            onClick={aceitar}
            className="flex-1 md:flex-none px-5 py-2.5 rounded-xl bg-gradient-to-r
              from-blue-600 to-indigo-600 text-white text-sm font-bold
              hover:shadow-lg hover:shadow-blue-200 transition-all"
          >
            Aceitar cookies
          </button>
          <button
            onClick={() => setVisivel(false)}
            className="p-2 text-gray-400 hover:text-gray-600 hover:bg-gray-100
              rounded-lg transition-colors flex-shrink-0"
            title="Fechar"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;